import { Suspense } from "react";
import { DataLoading } from "../loading";

export const SuspenseLoad = ({ component }) => {
  return <Suspense fallback={<DataLoading />}>{component}</Suspense>;
};
